import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {AnalyticsService} from '../../../services/analytics.service';
import {Router} from '@angular/router';
import {UserService, WaitResult} from '../../../services/user.service';
import {filter, shareReplay, take} from 'rxjs';
import {ProgressSpinner} from 'primeng/progressspinner';
import {AsyncPipe} from "@angular/common";
import {ActivatedRoute} from '@angular/router';
import typia from "typia";
import {MessageService} from "primeng/api";

@Component({
  selector: 'homey-deferred-payment-success-page',
  standalone: true,
  imports: [ProgressSpinner, AsyncPipe],
  templateUrl: './deferred-payment-success-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeferredPaymentSuccessPageComponent {
  private readonly analyticsService = inject(AnalyticsService);
  private readonly router = inject(Router);
  private readonly userService = inject(UserService);
  private readonly route = inject(ActivatedRoute);
  private readonly messageService = inject(MessageService);
  private readonly isInterval = typia.createIs<'annual' | 'monthly'>();
  protected readonly settled$ = this.userService.waitUntilDeferredPaymentSettled().pipe(
    shareReplay(1),
  );

  constructor() {
    const intervalFromQuery = this.route.snapshot.queryParamMap.get('interval');
    const interval = this.isInterval(intervalFromQuery) ? intervalFromQuery : 'unknown';
    void this.analyticsService.sendPaymentSuccess({
      flow: 'initial',
      checkoutLocation: 'deferred',
      interval,
      amount: 15,
    });

    this.settled$
      .pipe(
        filter((result) => result !== 'waiting'),
        take(1),
        takeUntilDestroyed(),
      )
      .subscribe(result => {
        if (result === 'done') {
          void this.router.navigate(
            ['/profile', 'update', 'income-assets-info', 'complete'],
            {queryParams: {payment: 'trial-started'}}
          );
        } else if (result === 'unauthorized') {
          this.messageService.add({severity: 'warn', summary: 'Session expired', detail: 'Please log in again.'});
          void this.router.navigateByUrl('/login');
        } else {
          this.messageService.add({severity: 'warn', summary: 'Timed out', detail: 'Redirected back to home.'});
          void this.router.navigateByUrl('/');
        }
      });
  }
}
